import { Overlay } from '@shared/ui/kit/overlay';
import { ModalProps } from '../model/types';
import Window from './window';

const Modal = (props: ModalProps) => {
  const { active = true } = props;

  return (
    <Overlay active={active}>
      <Window {...props} />
    </Overlay>
  );
};

export default Modal;
